export enum EOperationMode {
  /// <summary>
  /// ID만으로 인증
  /// </summary>
  ID_ONLY = 1,
  /// <summary>
  /// ID와 PIN으로 인증
  /// </summary>
  ID_AND_PIN,
  /// <summary>
  /// ID 두 개로 인증
  /// </summary>
  DUAL_ID
}
